import type { FeedbackType } from './userFeedback';

type Opener = (type?: FeedbackType, category?: string, error?: string) => void;

let opener: Opener | null = null;

export function setFeedbackOpener(fn: Opener | null): void {
  opener = fn;
}

export function openFeedback(
  type?: FeedbackType,
  category?: string,
  error?: string,
): void {
  opener?.(type, category, error);
}
